import React from 'react';
import { useT } from '@repo/common';
import RichText from './RichText';

const AboutTheRole = ({ job }) => {
  const t = useT();
  const content = job?.aboutRole?.trim() || '-';

  return (
    <div>
      <div className='flex flex-col items-start py-[30px] w-full gap-2 tabletH:gap-4 text-text-primary '>
        <div className='typo-b18Strong self-stretch'>
          {t('About the role', '포지션 소개')}
        </div>
        <RichText text={content} />
      </div>

      <div className='border-b border-grayscale-gray02' />
    </div>
  );
};

export default AboutTheRole;
